export * from './ActorFunctionFactoryTermMultiplication';
